module.exports = __webpack_public_path__ + "media/images/icons/select-arrows-28ab244a01b35316d2c5395ccb25f062.svg";